import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  mt: 1,
};

export const header: SxStyle = {
  p: (p) => p.spacing(2),
  color: (p) => p.palette.primary[600],
  background: (p) => p.palette.primary[50],
  borderBottomWidth: '1px',
  borderBottomColor: (p) => p.palette.primary[100],
  borderBottomStyle: 'solid',
};

export const footer: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const leftAction: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const rightAction: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: (p) => p.spacing(1),
};

export const columnHeader: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: (p) => p.spacing(1),
};

export const leftContent: SxStyleFunc<boolean | undefined> = (mdDown) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: (p) => p.spacing(1.5),
  borderRightWidth: mdDown ? '0px' : '1px',
  borderRightColor: mdDown ? 'transparent' : (p) => p.palette.grey[300],
  borderRightStyle: mdDown ? 'unset' : 'solid',
  gap: (p) => p.spacing(1),
});

export const rightContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: (p) => p.spacing(1.5),
  paddingBottom: 0,
  gap: (p) => p.spacing(1),
};

export const scrollbar: SxStyle = {
  height: (p) => p.spacing(38),
};
